import makeCachedRequest from "../../helpers/cached-request";
import { minutesToSeconds } from "../../helpers/date";
import { isServerDownError } from "../../helpers/http";
import logger from "../../helpers/logger";
import { IUser } from "../../interfaces";
import UserService from "../../services/user-service";

let clearCachedCurrentUser: () => void;

export function clearCachedUser(): void {
  clearCachedCurrentUser?.();
}

export async function fetchCurrentUser(): Promise<IUser | null> {
  try {
    // If we have the user cached, just return it.
    // Otherwise, make a request to fetch the user
    // and then cache the response if successful.
    const response = await makeCachedRequest(UserService.getCurrentUser, {
      cacheKey: process.env.CACHED_USER_KEY || "cached_user",
      expiresIn: minutesToSeconds(Number(process.env.ACCESS_TOKEN_EXPIRY) || 15), // Let this expire at the same time as the access token on the API side
      isSuccessfulRequest: (data) => !!(data?.user), // Cache the result only if data.user is not null
    });

    const { data, clearCachedResponse } = response;

    clearCachedCurrentUser = clearCachedResponse;

    return (data?.user as unknown) as IUser | null;
  } catch(error) {
    logger.error(
      "store::currentUser::fetchCurrentUser:: Error fetching current user",
      error
    );
  
    if(isServerDownError(error)) {
      throw error;
    }

    return null;
  }
}
